import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { twMerge } from 'tailwind-merge';

@Component({
  standalone: true,
  selector: 'app-btn',
  templateUrl: './btn.component.html',
  imports: [CommonModule],
  styleUrls: ['./btn.component.scss']
})
export class BtnComponent {
  defaultClasses: string = 'block md:w-[254px] w-full max-w-full'

  @Input() disabled?: boolean | null = false
  @Input() type?: string = 'button'
  @Input() gradient?: boolean = false

  @Output() public onClick: EventEmitter<void> = new EventEmitter()

  constructor(private hostElement: ElementRef) {
    hostElement.nativeElement.classList = twMerge(this.defaultClasses, hostElement.nativeElement.classList)
  }
}
